module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-500italic.4590ebba421b3288c305305d7fa7b504.woff2";